
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RestartQuizButton',

  emits: ['restartQuiz']
});
